<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAcesso } from 'dashboard/composables/useAcesso';
import wootConstants from 'dashboard/constants/globals';
import ChatdataImport from './ChatdataImport.vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

// O import do histórico do ChatData é do administrador da conta e do super admin: o `contacts:manage` com a chave
// `ACESSO_GRANULAR` ligada, como no servidor (`ChatdataImportPolicy`).
const { isAdmin, isSuperAdmin } = useAdmin();
const { decide } = useAcesso();
const podeImportar = computed(() =>
  decide('contacts:manage', () => isAdmin.value || isSuperAdmin.value)
);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <woot-tabs
    :index="activeTabIndex"
    class="justify-center w-full px-3 -mt-1 py-0 [&_ul]:p-0 [&_ul]:gap-[30px] [&_li]:!mx-0 h-10"
    @change="onTabChange"
  >
    <woot-tabs-item
      v-for="(item, index) in items"
      :key="item.key"
      class="text-sm [&_a]:font-medium"
      :index="index"
      :name="item.name"
      :count="item.count"
      is-compact
    />
    <template #actions>
      <ChatdataImport v-if="podeImportar" />
    </template>
  </woot-tabs>
</template>
